import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DataTable from "examples/Tables/DataTable";
import { Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PreviewIcon from "@mui/icons-material/Preview";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css"

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
const user = JSON.parse(sessionStorage.getItem("user"));
const role = user?.role;

function MeritList() {
  const [openDialog, setOpenDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [meritLists, setMeritLists] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [degrees, setDegrees] = useState([]);
  const [selectedDegree, setSelectedDegree] = useState("");
  const [inputs, setInputs] = useState({
    matric: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    fsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    bsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    ms: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    phd: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    uolTest: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
  });
  const [generatedMeritList, setGeneratedMeritList] = useState([]);
  const [seats, setSeats] = useState(0);
  const [openFormula, setOpenFormula] = useState(false);
  const [meritApplications, setMeritApplications] = useState([]);
  const [metric, setMetric] = useState(0);
  const [fsc, setFsc] = useState(0);
  const [bsc, setBsc] = useState(0);
  const [ms, setMs] = useState(0);
  const [phd, setPhd] = useState(0);
  const [uolTest, setUolTest] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const [meritId, setMeritId] = useState(null);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleView = async (merit_list) => {
    setOpenViewDialog(true);
    setMeritId(merit_list.id);
    setMetric(merit_list.metric);
    setFsc(merit_list.fsc);
    setBsc(merit_list.bsc);
    setMs(merit_list.ms);
    setPhd(merit_list.phd);
    setUolTest(merit_list.uol_test);
    if (merit_list.status == null) {
      setShowButtons(true);
    }
    let merit_id = merit_list.id;
    const response = await fetch(
      BASE_URL + "/application/get_merit_applications_merit_id/" + merit_id,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );
    const data = await response.json();
    setMeritApplications(data.merit_applications);
  };
  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCampaign("");
    setSelectedDepartment("");
    setSelectedDegree("");
    setInputs({
      matric: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
      fsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
      bsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
      ms: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
      phd: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
      uolTest: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
    });
    setSeats(0);
    setGeneratedMeritList([]);
    setOpenFormula(false);
  };
  const getCampaigns = async () => {
    try {
      const response = await fetch(
        BASE_URL + "/campaign/get_active_campaigns",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.campaigns && Array.isArray(data.campaigns)) {
        setCampaigns(data.campaigns);
      } else {
        toast.error("Failed to load campaigns");
      }
    } catch (error) {
      toast.error("An error occurred while fetching campaigns.");
      console.error(error);
    }
  };
  const getAssignDepartments = async () => {
    try {
      const response = await fetch(
        BASE_URL + "/department/get_users_departments",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const data = await response.json();

      // Ensure data contains 'departments' and it's an array
      if (data.departments && Array.isArray(data.departments)) {
        setDepartments(data.departments);
      } else {
        toast.error("Failed to load departments");
      }
    } catch (error) {
      toast.error("An error occurred while fetching departments.");
      console.error(error);
    }
  };

  const getDegreesByDepartment = async (departmentId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/degree/get_degrees_by_department/${departmentId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.degrees && Array.isArray(data.degrees)) {
        setDegrees(data.degrees);
      } else {
        toast.error("Failed to load degrees");
      }
    } catch (error) {
      toast.error("An error occurred while fetching degrees.");
      console.error(error);
    }
  };

  useEffect(() => {
    getAssignDepartments();
    getCampaigns();
  }, []);

  const handleDepartmentChange = (event) => {
    const departmentId = event.target.value;
    setSelectedDepartment(departmentId);
    if (departmentId) {
      getDegreesByDepartment(departmentId);
    }
  };

  const handleDegreeChange = (event) => {
    setSelectedDegree(event.target.value);
    setOpenFormula(true);
  };
  const handleCampaignChange = (event) => {
    setSelectedCampaign(event.target.value);
  };

  const handleInputChange = (field, value) => {
    setInputs({
      ...inputs,
      [field]: {
        ...inputs[field],
        userPercentage: value,
      },
    });
  };

  const handleGenerate = async () => {
    // Handle form submission or calculation here
    let data = {
      campaign_id: selectedCampaign,
      department_id: selectedDepartment,
      degree_id: selectedDegree,
      metric: inputs.matric.userPercentage,
      fsc: inputs.fsc.userPercentage,
      bsc: inputs.bsc.userPercentage,
      ms: inputs.ms.userPercentage,
      phd: inputs.phd.userPercentage,
      uol_test: inputs.uolTest.userPercentage,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(
      `${BASE_URL}/application/generate_merit_list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.seats) {
          setGeneratedMeritList(data.merit_list);
          setSeats(data.seats);
          setOpenFormula(false);
          toast.success("Merit list generated successfully!");
        } else {
          toast.error("Failed to generate merit list");
        }
      });
  };
  const handleSendMeritList = async () => {
    let data = {
      campaign_id: selectedCampaign,
      department_id: selectedDepartment,
      degree_id: selectedDegree,
      metric: inputs.matric.userPercentage,
      fsc: inputs.fsc.userPercentage,
      bsc: inputs.bsc.userPercentage,
      ms: inputs.ms.userPercentage,
      phd: inputs.phd.userPercentage,
      uol_test: inputs.uolTest.userPercentage,
      merit_list: generatedMeritList,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(`${BASE_URL}/application/add_merit_list`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setOpenDialog(false);
          setSelectedCampaign("");
          setSelectedDepartment("");
          setSelectedDegree("");
          setInputs({
            matric: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
            fsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
            bsc: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
            ms: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
            phd: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
            uolTest: { weightage: 50, userPercentage: 0, systemPercentage: 0 },
          });
          setSeats(0);
          setGeneratedMeritList([]);
          setOpenFormula(false);
          toast.success("Merit list send successfully!");
        } else {
          toast.error("Failed to generate merit list");
        }
      });
  };
  const handleCampaignTypeChange = async (event) => {
    const campaignId = event.target.value;
    setSelectedCampaign(campaignId);
    getMeritByCampaign(campaignId);
  };
  const getMeritByCampaign = async (id) => {
    let campaignId = id;
    let data = {
      campaign_id: campaignId,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };

    await fetch(
      `${BASE_URL}/application/get_merit_list_by_campaign`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.merits) {
          console.log(data.merits);
          setMeritLists(data.merits);
        } else {
          setMeritLists([]);
        }
      });
  };
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = [];
  for (let i = 0; i < meritLists.length; i++) {
    rows.push({
      serial: i + 1,
      name: meritLists[i].name,
      status: meritLists[i].status,
      actions: (
        <>
          <IconButton
            style={{ color: "green" }}
            onClick={() => handleView(meritLists[i])}
          >
            <PreviewIcon />
          </IconButton>
        </>
      ),
    });
  }
  const handleApprove = async (id) => {
    fetch(`${BASE_URL}/application/approve_merit_list/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    }).then((response) => {
      if (response.status === 200) {
        toast.success("Approved successfully");
        getMeritByCampaign(selectedCampaign);
        setOpenViewDialog(false);
      } else {
        toast.error("Failed to approve");
      }
    });
  };

  const handleReject = async (id) => {
    fetch(`${BASE_URL}/application/reject_merit_list/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    }).then((response) => {
      if (response.status === 200) {
        toast.success("Rejected successfully");
        getMeritByCampaign(selectedCampaign);
        setOpenViewDialog(false);
      } else {
        toast.error("Failed to reject");
      }
    });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <div className="ml-4 mt-3 col-md-3">
              <label>Campaign</label>
              <select
                className="form-control"
                onChange={handleCampaignTypeChange}
                value={selectedCampaign}
                style={{
                  width: "333px",
                  height: "40px",
                }}
              >
                <option value="" style={{ color: "gray", fontSize: "16px" }}>
                  Select Campaign
                </option>
                {campaigns.map((campaign) => (
                  <option key={campaign.id} value={campaign.id}>
                    {campaign.name}
                  </option>
                ))}
              </select>
            </div>
            <Card
              className="mt-5 card1"
              
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Button
                  variant="outlined"
                  endIcon={
                    <AddIcon
                        className="add-icon"
                    />
                  }
                  onClick={handleOpenDialog}
                   className="add-full-button"
                >
                  Make Merit List
                </Button>
              </MDBox>
              <MDBox pt={3}>
                {meritLists && meritLists.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src="nodata.png"
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Dialog for Merit List */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Create Merit List</DialogTitle>
        <DialogContent>
          <p>Enter details for the merit list.</p>
          <div className="row">
            <div className="col-md-4">
              <label>Campaign</label>
              <select
                className="form-control"
                onChange={handleCampaignChange}
                value={selectedCampaign}
              >
                <option value="">Select Campaign</option>
                {campaigns.map((campaign) => (
                  <option key={campaign.id} value={campaign.id}>
                    {campaign.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label>Department</label>
              <select
                className="form-control"
                onChange={handleDepartmentChange}
                value={selectedDepartment}
              >
                <option value="">Select Department</option>
                {departments.map((department) => (
                  <option key={department.id} value={department.id}>
                    {department.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label>Degree</label>
              <select
                className="form-control"
                onChange={handleDegreeChange}
                value={selectedDegree}
              >
                <option value="">Select Degree</option>
                {degrees.map((degree) => (
                  <option key={degree.id} value={degree.id}>
                    {degree.program_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {openFormula && (
            <div className="mt-3">
              <table className="table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Your Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(inputs).map((field) => (
                    <tr key={field}>
                      <td>{field.toUpperCase()}</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={inputs[field].userPercentage}
                          onChange={(e) =>
                            handleInputChange(field, e.target.value)
                          }
                          placeholder={`Enter ${field} percentage`}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Button
                color="primary"
                onClick={handleGenerate}
                style={{
                  marginTop: "20px",
                  display: "block",
                  marginLeft: "auto",
                }}
              >
                Generate
              </Button>
            </div>
          )}

          {generatedMeritList.length > 0 && (
            <div className="mt-3">
              <h6>Total Seats for Selected Degree: {seats}</h6>
              <table className="table">
                <thead>
                  <tr>
                    <th>Application Id</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Aggregrate</th>
                  </tr>
                </thead>
                <tbody>
                  {generatedMeritList.map((student) => (
                    <tr key={student.id}>
                      <td>{student.application_form_id}</td>
                      <td>{student.first_name}</td>
                      <td>{student.last_name}</td>
                      <td>{student.aggregrate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          {generatedMeritList.length > 0 && (
            <Button onClick={handleSendMeritList} color="primary">
              Send to Admission Incharge
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={openViewDialog}
        onClose={handleCloseViewDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>View Merit List</DialogTitle>
        <DialogContent>
          <h5>Formula Applied:</h5>
          <h6>Matric Percentage: {metric}%</h6>
          <h6>Fsc Percentage: {fsc}%</h6>
          <h6>BSC Percentage: {bsc}%</h6>
          <h6>MS Percentage: {ms}%</h6>
          <h6>PHD Percentage: {phd}%</h6>
          <h6>UOL Test Percentage: {uolTest}%</h6>
          <table className="table">
            <thead>
              <tr>
                <th>Application Id</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Aggregrate</th>
              </tr>
            </thead>
            <tbody>
              {meritApplications.map((student) => (
                <tr key={student.id}>
                  <td>{student.application_form_id}</td>
                  <td>{student.first_name}</td>
                  <td>{student.last_name}</td>
                  <td>{student.aggregrate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewDialog} color="primary">
            Close
          </Button>
          {role == "admission-incharge" && showButtons == true && (
            <>
              <Button
                onClick={() => {
                  handleApprove(meritId);
                }}
                color="primary"
              >
                Approve
              </Button>
              <Button
                onClick={() => {
                  handleReject(meritId);
                }}
                color="primary"
              >
                Reject
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default MeritList;
